import { useCurrency } from "@/context/CurrencyContext";

export function CurrencySwitch({ className = "" }) {
  const { currency, setCurrency } = useCurrency();
  const opts = [
    { id: "eur", label: "€ EUR" },
    { id: "usd", label: "$ USD" },
  ];
  return (
    <div
      className={`inline-flex items-center p-1 rounded-full glass border border-white/12 ${className}`}
      data-testid="currency-switch"
    >
      {opts.map((o) => (
        <button
          key={o.id}
          type="button"
          onClick={() => setCurrency(o.id)}
          data-testid={`currency-${o.id}`}
          aria-pressed={currency === o.id}
          className={`px-3.5 py-1.5 rounded-full text-xs font-semibold transition-colors ${
            currency === o.id ? "bg-primary text-primary-foreground" : "text-foreground/55 hover:text-primary"
          }`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
